import { render, staticRenderFns } from "./rekoncadb.vue?vue&type=template&id=339e13a6"
import script from "./rekoncadb.vue?vue&type=script&lang=js"
export * from "./rekoncadb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports